// extracted by mini-css-extract-plugin
export default {"box":"fxGUw5sFRVcBAMsIQOhM"};